window.BrowserWindow = require("electron").remote.BrowserWindow;
window.env = process.env;

var timer = undefined
require('electron').ipcRenderer.on('message', function(event, message) {
    console.log("ipcRenderer on message: ", message);
    if (message.length <= 150 && document.getElementById("ipc_messages")) {
        document.getElementById("ipc_messages").textContent = message;
        document.getElementById("ipc_messages").style.display = "block";
        clearTimeout(timer);
        timer = setTimeout(function() {
            document.getElementById("ipc_messages").style.display = "none";
            document.getElementById("ipc_messages").textContent = "";
        }, 2000);
    }
});

require('electron').ipcRenderer.on('serialport', function(event, serialport) {
    console.log("ipcRenderer on serialport: ", serialport);
    window.current_serialport = serialport;
});

require('electron').ipcRenderer.on('license_key', function(event, license_key) {
    console.log("ipcRenderer on license_key: ", license_key);
    window.LICENSE_KEY = license_key;
});

require('electron').ipcRenderer.on('current_scope', function(event, current_scope) {
    console.log("ipcRenderer on current_scope: ", current_scope);
    window.CURRENT_SCOPE = current_scope;
});
console.log('browser.js is loaded');
